export const arrayGroupBy = (array: any[], key: string) =>
  array.reduce((acc, x) => {
    const arr = (acc[x[key]] = acc[x[key]] || []) as Array<any>;
    arr.push(x);
    return acc;
  }, {});
